import { Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, LOEWE_IMAGE_UPLOAD_FIELD_PROPS } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';

// import schemas
import { get } from 'lodash';
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
import { getFormStrucWithoutComponentTable, mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath, checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
const P = AntragSchema.attributes;

const InnovationsgradSkizzeLoewe: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<ApplicationHeading title={'Innovationsgrad und Alleinstellungsmerkmale'} />
			<Typography>
				<strong>Bitte gehen Sie auf folgende Bereiche ein:</strong> Erläutern Sie inwiefern die Lösung innovativ ist und sich von bestehenden
				Produkten/Dienstleistungen unterscheidet und auch welche neuen oder verbesserten Ansätze verfolgt werden bzw. welches
				Alleinstellungsmerkmal das neue Produkt/die neue Dienstleistung einzigartig macht. Ziel ist es aufzuzeigen, welchen besonderen Mehrwert
				die Innovation gegenüber bestehenden Lösungen bietet. 
			</Typography>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default InnovationsgradSkizzeLoewe;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Erlaeuterung_Resultierenden_Mehrwerts, maxCharLength: 5500, hideLabel: true },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStruc = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucInnovationsgradSkizzeLoewe = (application: any) => {
	let result: FormStrucItem[] = [];
	const bilderLength = get(application, P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder.path, []).length;

	//check if there are images, if yes then validate the additional fields for each image
	for (let i = 0; i < bilderLength; i++) {
		//map customFOrmStruc with index to each path
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStruc(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Bilder,
		);
		result = concat(result, customFormStrucWithIndex);
	}

	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Pruefstatus.path,
			P.Projektbeschreibung_Loewe.schema.attributes.Alleinstellungsmerkmale_Erledigt.path,
		)
	) {
		result = concat(result, formStrucPruefAssistenz());
	}
	result = concat(result, getFormStrucWithoutComponentTable(formStruc()));

	return result;
};
